<template>
  <div v-if="info?.length" class="rating-wrapper">
    <template v-for="(item, index) in info">
      <RichText
        class="rich-text-line"
        :class="{ 'last-line': index === info.length - 1 }"
        :key="`rating-${index}`"
        :text="(item.icon || '') + (item.content || '')"
        :isArgb="true"
      />
      <span
        v-if="index < info.length - 1"
        :key="`rating-point-${index}`"
        class="point-gap"
      ></span>
    </template>
    <i class="icon-arrow icon-v3_small_outlined_entrance"></i>
  </div>
</template>
<script>
import RichText from '@/components/RichText/index.vue';

export default {
  components: {
    RichText,
  },
  props: {
    info: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.rating-wrapper {
  .rich-text-line {
    &:first-child .rich-text-icon {
      margin-right: rem(8);
    }
    &.last-line span {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
<style lang="scss" scoped>
.rating-wrapper {
  display: flex;
  align-items: center;
  line-height: rem(32);
  .rich-text-line {
    display: flex;
    align-items: center;
    &.last-line {
      margin-right: rem(4);
      overflow: hidden;
    }
  }
  .point-gap {
    flex-shrink: 0;
    display: inline-block;
    margin: 0 rem(8);
    width: rem(4);
    height: rem(4);
    border-radius: 50%;
    background: #000;
  }
  .icon-arrow {
    font-size: 12px;
  }
}
</style>
